<template>
  <base-field
    :label="label"
    :id="$attrs.id"
    :error-messages="errorMessages"
    class="range-input"
    layout=""
  >
    <div class="range-input">
      <div class="range-input__wrap">
        <label
          v-for="item in rangeIterator"
          :key="item"
          :class="{ 'range-input__label--active': isInRange(item, value) }"
          :for="`${name}-${item}`"
          class="range-input__label"
        >
          {{ item }}
          <input
            :id="`${name}-${item}`"
            :value="item"
            :name="name"
            type="radio"
            class="range-input__item"
            :checked="item === value"
            @change="$emit('change', item)"
          />
        </label>
      </div>
    </div>
    <div class="range-input__indicators">
      <p v-if="lowIndicator" class="range-input__indicators__low">{{ lowIndicator }}</p>
      <p v-if="highIndicator" class="range-input__indicators__high">{{ highIndicator }}</p>
    </div>
  </base-field>
</template>

<script>
import BaseField from '@/components/base-field';

export default {
  name: 'BaseRangeSelector',
  model: {
    prop: 'value',
    event: 'change',
  },
  components: {
    BaseField,
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    range: {
      type: Array,
      default: () => [],
    },
    rangeNumber: {
      type: Number,
      default: 10,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    lowIndicator: {
      type: String,
      default: '',
    },
    highIndicator: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rangeIterator() {
      return this.range.length ? this.range : this.rangeNumber;
    },
  },
  methods: {
    // @todo: add ability to pass custom function for isInRange
    isInRange(item, value) {
      return item <= value;
    },
  },
};
</script>

<style lang="scss">
.range-input {
  .base-field {
    &__label {
      color: #858585;
      font-weight: 300;
    }
  }
}
</style>

<style lang="scss" scoped>
.range-input {
  display: inline-flex;
  flex-direction: column;

  &__wrap {
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  &__item {
    opacity: 0;
    position: fixed;
    width: 0;
  }

  &__label {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    margin-right: 1px;
    padding: 4px 8px;
    cursor: pointer;
    color: #0088db;
    background-color: #f9f9f9;
    font-size: 14px;
    font-weight: 500;

    @media screen and (min-width: 360px) {
      padding: 6px 11px;
    }

    @media screen and (min-width: 375px) {
      padding: 6px 12px;
    }

    &--active {
      background-color: #0088db;
      color: white;
    }
  }

  &__indicators {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding: 0;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;

    &__low {
      color: #858585;
    }

    &__high {
      color: #0088db;
    }
  }

  .errors {
    font-size: 12px;
    min-height: 18px;
  }
}
</style>
